const testimonials = [
  {
    quote: "웹툰 스튜디오 유형으로 수업을 설계했는데, 학생들이 에디터·계약 MD·법무 역할을 나눠 맡아서 실제 IP 라이선싱 계약서를 검토하는 과정이 정말 생생했어요. 표준 계약서에서 독소 조항을 직접 찾아낼 때 학생들의 눈빛이 달라졌습니다.",
    name: "정은현 교수",
    role: "예술경영학과 — 문화콘텐츠 비즈니스 수업 담당",
    avatar: "정",
    tag: "강사 후기",
    accent: "#4B6CF7",
  },
  {
    quote: "뮤직 레이블에서 A&R 역할을 맡았는데, AI NPC 유통사와 정산 협상하다가 팀 재무 담당이 전표를 잘못 처리해서 자본금이 한 번에 800만원 빠진 적이 있어요. 그 순간 다들 진짜 회의 들어간 것처럼 긴장했고, 회계가 왜 중요한지 몸으로 배웠습니다.",
    name: "김민준",
    role: "수강생 — 실용음악 전공 3학년",
    avatar: "김",
    tag: "수강생 후기",
    accent: "#7C3AED",
  },
  {
    quote: "이벤트 디스패처에서 'VC 지분 투자 제안' 이벤트를 발송했더니 팀마다 반응이 완전히 달랐어요. 즉시 수락한 팀, 지분 재협상한 팀, 거절한 팀 세 가지가 나왔고, 결과 차이를 가지고 수업 후반 30분 토론이 자연스럽게 이어졌습니다.",
    name: "이유정 강사",
    role: "엔터테인먼트 비즈니스 워크숍 진행",
    avatar: "이",
    tag: "강사 후기",
    accent: "#4B6CF7",
  },
  {
    quote: "공연기획사 재무 담당을 했는데, 스폰서 수익 정산 전표를 처리하다가 부가세 항목을 빠뜨려서 세무 이벤트가 왔어요. 교수님이 발송하신 '세무조사 통보' 이벤트랑 겹쳐서 한 턴에 위기가 두 개 터졌고, 그게 가장 생생한 기억입니다.",
    name: "박서윤",
    role: "수강생 — 문화예술경영 전공 졸업생",
    avatar: "박",
    tag: "수강생 후기",
    accent: "#7C3AED",
  },
  {
    quote: "God Mode 대시보드에서 팀별 자본금 추이를 보면서 어떤 팀이 위기 이벤트를 잘 넘겼는지 한눈에 파악할 수 있어요. 중간에 최하위 팀에게 '기회 이벤트'를 발송해 역전 기회를 줬더니 수업 분위기가 확 살아났습니다.",
    name: "최준혁 교수",
    role: "공연예술경영학과 — 현장실습 연계 수업 담당",
    avatar: "최",
    tag: "강사 후기",
    accent: "#4B6CF7",
  },
  {
    quote: "광고·콘텐츠 에이전시에서 데이터 분석가 역할을 했는데, 캠페인 성과 리포트를 작성하고 CPM·전환율 수치를 해석해야 했어요. 마케팅 수업에서 이렇게 실전 데이터를 다뤄본 건 처음이었고, 포트폴리오에도 그 경험을 그대로 쓸 수 있었습니다.",
    name: "오하은",
    role: "수강생 — 디지털마케팅 전공 졸업",
    avatar: "오",
    tag: "수강생 후기",
    accent: "#7C3AED",
  },
];

const PD = "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, sans-serif";

export default function TestimonialsSection() {
  return (
    <section className="bg-[#F9F9F9] py-16 md:py-24 lg:py-32" style={{ fontFamily: PD }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 text-[#4B6CF7] text-xs font-medium uppercase tracking-widest mb-4 bg-[#4B6CF7]/[0.07] px-3 py-1.5 rounded-full border border-[#4B6CF7]/15">
            <i className="ri-chat-quote-line text-xs"></i> Testimonials
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111] leading-snug mb-3">
            강사와 수강생의 이야기
          </h2>
          <p className="text-[#888888] text-sm max-w-lg mx-auto">
            실제 수업에서 경험한 생생한 순간들을 담았습니다.
          </p>
        </div>

        {/* Grid 2×3 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-black/[0.08] rounded-2xl p-6 flex flex-col hover:border-black/[0.14] transition-all"
            >
              <div className="flex items-center justify-between mb-4">
                <span
                  className="text-[10px] px-2 py-0.5 rounded-full font-medium border"
                  style={{
                    background: `${t.accent}09`,
                    borderColor: `${t.accent}25`,
                    color: t.accent,
                  }}
                >
                  {t.tag}
                </span>
                <i className="ri-double-quotes-l text-2xl" style={{ color: `${t.accent}20` }}></i>
              </div>

              <p className="text-[#555555] text-sm leading-relaxed flex-1 mb-5">{t.quote}</p>

              <div className="flex items-center gap-3 border-t border-black/[0.06] pt-4">
                <div
                  className="w-9 h-9 flex items-center justify-center rounded-xl text-sm font-bold shrink-0"
                  style={{ backgroundColor: `${t.accent}12`, color: t.accent }}
                >
                  {t.avatar}
                </div>
                <div>
                  <p className="text-[#111111] text-xs font-semibold">{t.name}</p>
                  <p className="text-[#AAAAAA] text-[10px] mt-0.5 leading-snug">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="mt-12 bg-white border border-[#4B6CF7]/20 rounded-2xl p-8 md:p-10 text-center shadow-sm">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#4B6CF7]/10 border border-[#4B6CF7]/20 mx-auto mb-4">
            <i className="ri-rocket-line text-[#4B6CF7] text-xl"></i>
          </div>
          <h3 className="text-[#111111] text-xl md:text-2xl font-bold mb-3 leading-snug">
            지금 바로 경험해보세요
          </h3>
          <p className="text-[#888888] text-sm mb-6">
            강의실에서 문화예술 기업의 CEO가 되는 경험, K-ArtPEN으로 시작합니다.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="/login"
              className="w-full sm:w-auto bg-[#4B6CF7] hover:bg-[#5B7CF7] text-white font-semibold text-sm px-8 py-3 rounded-xl transition-all cursor-pointer whitespace-nowrap"
            >
              무료로 시작하기 <i className="ri-arrow-right-line ml-1"></i>
            </a>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }); }}
              className="w-full sm:w-auto bg-[#F5F5F5] border border-black/[0.09] hover:bg-[#EEEEEE] text-[#333333] text-sm px-8 py-3 rounded-xl transition-all cursor-pointer whitespace-nowrap"
            >
              기관 도입 문의
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
